var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManutencaoVerde(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.935,
    height: 20,
    viewBox: "0 0 19.935 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 19.935,
    height: 20,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.935,
    height: 20,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(54,216,150)",
    fillRule: "evenodd",
    d: "M11.40200806 8.09899902l8.25900268 8.25994873c.1749878.16729737.27432251.3986206.27508545.64068604.00076294.24206543-.09713745.47399902-.27108765.64233398l-2.0920105 2.09197998c-.1699829.1704712-.40078735.26623536-.64151.26623536-.24069214 0-.47149658-.09576416-.6414795-.26623536L8.00201416 11.4459839c-2.44558716.93682861-5.21603394.14953613-6.80337524-1.93347168-1.58734131-2.08300782-1.6116333-4.96307373-.05963135-7.0725708L4.62301636 5.9239502l1.29199218-1.28497315-3.49301147-3.5C4.54898071-.41833496 7.45019531-.3786621 9.53378296 1.2362671c2.08361816 1.61486816 2.84573364 4.41448975 1.8682251 6.86273193zm-3.07601929 1.1090088l8.60598755 8.60699462.8050232-.8079834L9.1369934 8.40698242c.41152954-.5180664.68658447-1.13110351.7999878-1.78295898.22027587-1.23095703-.13577271-2.49487305-.96618653-3.42980957-.8303833-.93493653-2.04351807-1.4376831-3.29180908-1.36419678l2.81100463 2.81201172-3.8580017 3.85699463L1.82098389 5.6920166c-.06835938 1.22686768.41973877 2.41931152 1.32879638 3.24609375.90905762.82678223 2.14227295 1.19995117 3.35720826 1.01586914.6592102-.0925293 1.28463745-.34906006 1.81900024-.74597168z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManutencaoVerde);
export default __webpack_public_path__ + "static/media/manutencao_verde.85da191da365cd9755052780a92e40b1.svg";
export { ForwardRef as ReactComponent };